// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --dsg-border-color: var(--chakra-colors-gray-300);
  --dsg-selection-border-color: rgb(69, 128, 230);
  --dsg-selection-border-radius: 2px;
  --dsg-selection-border-width: 2px;
  --dsg-selection-background-color: rgba(69, 128, 230, 0.04);
  --dsg-selection-disabled-border-color: #9da6ab;
  --dsg-selection-disabled-background-color: rgba(0, 0, 0, 0.04);
  --dsg-corner-indicator-width: 10px;
  --dsg-header-text-color: var(--chakra-colors-gray-500);
  --dsg-header-active-text-color: black;
  --dsg-cell-background-color: white;
  --dsg-cell-disabled-background-color: rgb(250, 250, 250);
  --dsg-transition-duration: 0.1s;
  --dsg-expand-rows-indicator-width: 10px;
  --dsg-scroll-shadow-width: 7px;
  --dsg-scroll-shadow-color: rgba(0, 0, 0, 0.2);
}

.dsg-container {
  border: solid 1px var(--dsg-border-color);
  border-top: none;
  border-left: none;
  cursor: cell;
  user-select: none;
  box-sizing: border-box;
  color: black;
  background: white;
  position: relative;
  width: 100%;
  overflow: auto;
  will-change: transform;
  direction: ltr;
}

.dsg-corner-indicator {
  margin: auto;
  width: 0;
  border-bottom: solid var(--dsg-corner-indicator-width)
    var(--dsg-header-text-color);
  border-left: solid var(--dsg-corner-indicator-width) transparent;
}

.dsg-row {
  position: absolute;
  top: 0;
  left: 0;
  background: var(--dsg-cell-background-color);
  box-shadow: 0 1px var(--dsg-border-color) inset;
}

.dsg-row-header {
  position: sticky;
  top: 0;
  z-index: 40;
}

.dsg-cell {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background: var(--dsg-cell-background-color);
  border: solid 1px var(--dsg-border-color);
  border-bottom: none;
  border-right: none;
  box-shadow: 1px 1px var(--dsg-border-color);
  position: absolute;
  top: 0;
  height: 100%;
}

.dsg-hidden-cell {
  display: none;
}

.dsg-cell-sticky-right {
  position: sticky;
  right: 0;
  z-index: 30;
  margin-left: auto;
  transform: translateY(-100%);
}

.dsg-cell-disabled {
  background: var(--dsg-cell-disabled-background-color);
}

.dsg-cell-header,
.dsg-cell-gutter {
  color: var(--dsg-header-text-color);
  transition: color var(--dsg-transition-duration);
  box-shadow: none;
}

.dsg-cell-header-container {
  padding: 0 10px;
  line-height: 15px;
}

.dsg-cell-header.dsg-cell-gutter {
  box-shadow:
    1px 0 var(--dsg-border-color),
    0 1px var(--dsg-border-color);
}

.dsg-cell-header.dsg-cell-sticky-right {
  box-shadow: 0 1px var(--dsg-border-color);
}

.dsg-cell-gutter {
  position: sticky;
  left: 0;
  padding: 0 5px;
  justify-content: center;
  z-index: 30;
  height: 100%;
}

.dsg-cell-header-active,
.dsg-cell-gutter-active {
  color: var(--dsg-header-active-text-color);
}

.dsg-active-cell,
.dsg-selection-rect {
  position: absolute;
  border: solid var(--dsg-selection-border-width)
    var(--dsg-selection-border-color);
  box-sizing: border-box;
  border-radius: var(--dsg-selection-border-radius);
  transition: all var(--dsg-transition-duration);
  pointer-events: none;
  z-index: 20;
}

.dsg-active-cell-focus {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

.dsg-active-cell-disabled,
.dsg-selection-rect-disabled {
  border-color: var(--dsg-selection-disabled-border-color);
}

.dsg-selection-rect {
  background: var(--dsg-selection-background-color);
}

.dsg-selection-rect-disabled {
  background: var(--dsg-selection-disabled-background-color);
}

.dsg-scrollable-view-container {
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
}

.dsg-scrollable-view {
  position: sticky;
  z-index: 10;
  box-sizing: border-box;
  border: solid 1px var(--dsg-border-color);
  border-bottom: none;
  border-right: none;
  transition: box-shadow 0.3s;
  box-shadow:
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-t {
  box-shadow:
    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-r {
  box-shadow:
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-b {
  box-shadow:
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-l {
  box-shadow:
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-t.dsg-scrollable-view-r {
  box-shadow:
    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-r.dsg-scrollable-view-b {
  box-shadow:
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-b.dsg-scrollable-view-l {
  box-shadow:
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-l.dsg-scrollable-view-t {
  box-shadow:
    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-t.dsg-scrollable-view-b {
  box-shadow:
    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-l.dsg-scrollable-view-r {
  box-shadow:
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-t.dsg-scrollable-view-r.dsg-scrollable-view-b {
  box-shadow:
    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-r.dsg-scrollable-view-b.dsg-scrollable-view-l {
  box-shadow:
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-b.dsg-scrollable-view-l.dsg-scrollable-view-t {
  box-shadow:
    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-l.dsg-scrollable-view-t.dsg-scrollable-view-r {
  box-shadow:
    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-scrollable-view-t.dsg-scrollable-view-r.dsg-scrollable-view-b.dsg-scrollable-view-l {
  box-shadow:
    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset,
    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)
      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)
      inset;
}

.dsg-selection-col-marker-container {
  position: absolute;
  top: 0;
}

.dsg-selection-col-marker {
  background: var(--dsg-selection-border-color);
  position: sticky;
  width: 100%;
  height: var(--dsg-selection-border-width);
}

.dsg-selection-row-marker-container {
  position: absolute;
  left: 0;
}

.dsg-selection-row-marker {
  background: var(--dsg-selection-border-color);
  position: sticky;
  height: 100%;
  width: var(--dsg-selection-border-width);
}

.dsg-selection-col-marker-container,
.dsg-selection-col-marker,
.dsg-selection-row-marker-container,
.dsg-selection-row-marker {
  z-index: 20;
  transition: all var(--dsg-transition-duration);
  pointer-events: none;
}

.dsg-selection-col-marker-disabled,
.dsg-selection-row-marker-disabled {
  background: var(--dsg-selection-disabled-border-color);
}

.dsg-add-row {
  background: #fafafa;
  border: 1px solid var(--dsg-border-color);
  border-top: none;
  padding: 7px 10px;
  display: flex;
  align-items: center;
  color: black;
}

.dsg-add-row > * {
  margin-right: 10px;
}

.dsg-add-row-btn,
.dsg-add-row-input {
  background: white;
  padding: 7px 10px;
  display: flex;
  align-items: center;
  position: relative;
  border: 1px solid #dcdcdc;
  border-radius: 2px;
  transition: all 0.2s;
}

.dsg-add-row-input {
  width: 55px;
}

.dsg-add-row-btn:hover,
.dsg-add-row-input:hover {
  border-color: #c7c7c7;
}

.dsg-add-row-btn:focus,
.dsg-add-row-input:focus {
  border-color: var(--dsg-selection-border-color);
  outline: none;
}

.dsg-add-row-btn:before {
  content: '';
  display: inline-block;
  margin-right: 10px;
  background: #9da6ab;
  width: 10px;
  height: 2px;
}

.dsg-add-row-btn:after {
  content: '';
  display: block;
  position: absolute;
  left: 14px;
  margin-right: 10px;
  background: #9da6ab;
  width: 2px;
  height: 10px;
}

.dsg-input {
  display: block;
  flex: 1;
  border: none;
  min-width: 0;
  align-self: stretch;
  box-sizing: border-box;
  background: none;
  padding: 0 10px;
  outline: none;
}

.dsg-input,
.dsg-row {
  font-size: calc(0.75 * var(--bs-body-font-size));
}

.dsg-input-suffix {
  padding-right: 10px;
  opacity: 0.5;
  margin-left: -5px;
}

.dsg-input-align-right {
  text-align: right;
}

.dsg-hide-date-picker[type='date']::-webkit-inner-spin-button,
.dsg-hide-date-picker[type='date']::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

.dsg-checkbox {
  margin: auto;
}

.dsg-context-menu {
  position: fixed;
  background: white;
  z-index: 10000;
  border-radius: 4px;
  box-shadow: 0 2px 6px 2px rgba(60, 64, 67, 0.15);
  padding: 5px 0;
  color: black;
}

.dsg-context-menu-item {
  padding: 3px 20px;
  cursor: default;
}

.dsg-context-menu-item:hover {
  background: #fafafa;
}

.dsg-expand-rows-indicator {
  background: var(--dsg-cell-background-color);
  border: solid 1px var(--dsg-selection-border-color);
  box-shadow: 0 0 0 1px var(--dsg-cell-background-color);
  width: var(--dsg-expand-rows-indicator-width);
  height: var(--dsg-expand-rows-indicator-width);
  box-sizing: border-box;
  position: absolute;
  transition: all var(--dsg-transition-duration);
  cursor: crosshair;
  z-index: 25;
}

.dsg-expand-rows-indicator-disabled {
  border: solid 1px var(--dsg-selection-disabled-border-color);
}

.dsg-expand-rows-rect {
  position: absolute;
  box-sizing: border-box;
  transition: all var(--dsg-transition-duration);
  pointer-events: none;
  background: rgba(0, 0, 0, 0.03);
}
`, "",{"version":3,"sources":["webpack://./frontend/components/DataEditor/react-datasheet-grid.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,kCAAkC;EAClC,iCAAiC;EACjC,0DAA0D;EAC1D,8CAA8C;EAC9C,8DAA8D;EAC9D,kCAAkC;EAClC,sDAAsD;EACtD,qCAAqC;EACrC,kCAAkC;EAClC,wDAAwD;EACxD,+BAA+B;EAC/B,uCAAuC;EACvC,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR;gCAC8B;EAC9B,gEAAgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;EAEE,mCAAmC;EACnC,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;;iCAE+B;AACjC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,kBAAkB;EAClB;qCACmC;EACnC,sBAAsB;EACtB,iDAAiD;EACjD,8CAA8C;EAC9C,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,wDAAwD;AAC1D;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE;;;;;;;;;;;;WAYS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;;;;EAIE,WAAW;EACX,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,+CAA+C;EAC/C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gDAAgD;EAChD,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,mDAAmD;EACnD,sDAAsD;EACtD,6CAA6C;EAC7C,8CAA8C;EAC9C,sBAAsB;EACtB,kBAAkB;EAClB,8CAA8C;EAC9C,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,8CAA8C;EAC9C,oBAAoB;EACpB,+BAA+B;AACjC","sourcesContent":[":root {\n  --dsg-border-color: var(--chakra-colors-gray-300);\n  --dsg-selection-border-color: rgb(69, 128, 230);\n  --dsg-selection-border-radius: 2px;\n  --dsg-selection-border-width: 2px;\n  --dsg-selection-background-color: rgba(69, 128, 230, 0.04);\n  --dsg-selection-disabled-border-color: #9da6ab;\n  --dsg-selection-disabled-background-color: rgba(0, 0, 0, 0.04);\n  --dsg-corner-indicator-width: 10px;\n  --dsg-header-text-color: var(--chakra-colors-gray-500);\n  --dsg-header-active-text-color: black;\n  --dsg-cell-background-color: white;\n  --dsg-cell-disabled-background-color: rgb(250, 250, 250);\n  --dsg-transition-duration: 0.1s;\n  --dsg-expand-rows-indicator-width: 10px;\n  --dsg-scroll-shadow-width: 7px;\n  --dsg-scroll-shadow-color: rgba(0, 0, 0, 0.2);\n}\n\n.dsg-container {\n  border: solid 1px var(--dsg-border-color);\n  border-top: none;\n  border-left: none;\n  cursor: cell;\n  user-select: none;\n  box-sizing: border-box;\n  color: black;\n  background: white;\n  position: relative;\n  width: 100%;\n  overflow: auto;\n  will-change: transform;\n  direction: ltr;\n}\n\n.dsg-corner-indicator {\n  margin: auto;\n  width: 0;\n  border-bottom: solid var(--dsg-corner-indicator-width)\n    var(--dsg-header-text-color);\n  border-left: solid var(--dsg-corner-indicator-width) transparent;\n}\n\n.dsg-row {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: var(--dsg-cell-background-color);\n  box-shadow: 0 1px var(--dsg-border-color) inset;\n}\n\n.dsg-row-header {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n}\n\n.dsg-cell {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  background: var(--dsg-cell-background-color);\n  border: solid 1px var(--dsg-border-color);\n  border-bottom: none;\n  border-right: none;\n  box-shadow: 1px 1px var(--dsg-border-color);\n  position: absolute;\n  top: 0;\n  height: 100%;\n}\n\n.dsg-hidden-cell {\n  display: none;\n}\n\n.dsg-cell-sticky-right {\n  position: sticky;\n  right: 0;\n  z-index: 30;\n  margin-left: auto;\n  transform: translateY(-100%);\n}\n\n.dsg-cell-disabled {\n  background: var(--dsg-cell-disabled-background-color);\n}\n\n.dsg-cell-header,\n.dsg-cell-gutter {\n  color: var(--dsg-header-text-color);\n  transition: color var(--dsg-transition-duration);\n  box-shadow: none;\n}\n\n.dsg-cell-header-container {\n  padding: 0 10px;\n  line-height: 15px;\n}\n\n.dsg-cell-header.dsg-cell-gutter {\n  box-shadow:\n    1px 0 var(--dsg-border-color),\n    0 1px var(--dsg-border-color);\n}\n\n.dsg-cell-header.dsg-cell-sticky-right {\n  box-shadow: 0 1px var(--dsg-border-color);\n}\n\n.dsg-cell-gutter {\n  position: sticky;\n  left: 0;\n  padding: 0 5px;\n  justify-content: center;\n  z-index: 30;\n  height: 100%;\n}\n\n.dsg-cell-header-active,\n.dsg-cell-gutter-active {\n  color: var(--dsg-header-active-text-color);\n}\n\n.dsg-active-cell,\n.dsg-selection-rect {\n  position: absolute;\n  border: solid var(--dsg-selection-border-width)\n    var(--dsg-selection-border-color);\n  box-sizing: border-box;\n  border-radius: var(--dsg-selection-border-radius);\n  transition: all var(--dsg-transition-duration);\n  pointer-events: none;\n  z-index: 20;\n}\n\n.dsg-active-cell-focus {\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);\n}\n\n.dsg-active-cell-disabled,\n.dsg-selection-rect-disabled {\n  border-color: var(--dsg-selection-disabled-border-color);\n}\n\n.dsg-selection-rect {\n  background: var(--dsg-selection-background-color);\n}\n\n.dsg-selection-rect-disabled {\n  background: var(--dsg-selection-disabled-background-color);\n}\n\n.dsg-scrollable-view-container {\n  position: absolute;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n}\n\n.dsg-scrollable-view {\n  position: sticky;\n  z-index: 10;\n  box-sizing: border-box;\n  border: solid 1px var(--dsg-border-color);\n  border-bottom: none;\n  border-right: none;\n  transition: box-shadow 0.3s;\n  box-shadow:\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-t {\n  box-shadow:\n    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-r {\n  box-shadow:\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-b {\n  box-shadow:\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-l {\n  box-shadow:\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-t.dsg-scrollable-view-r {\n  box-shadow:\n    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-r.dsg-scrollable-view-b {\n  box-shadow:\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-b.dsg-scrollable-view-l {\n  box-shadow:\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-l.dsg-scrollable-view-t {\n  box-shadow:\n    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-t.dsg-scrollable-view-b {\n  box-shadow:\n    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-l.dsg-scrollable-view-r {\n  box-shadow:\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-t.dsg-scrollable-view-r.dsg-scrollable-view-b {\n  box-shadow:\n    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-r.dsg-scrollable-view-b.dsg-scrollable-view-l {\n  box-shadow:\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-b.dsg-scrollable-view-l.dsg-scrollable-view-t {\n  box-shadow:\n    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-l.dsg-scrollable-view-t.dsg-scrollable-view-r {\n  box-shadow:\n    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-scrollable-view-t.dsg-scrollable-view-r.dsg-scrollable-view-b.dsg-scrollable-view-l {\n  box-shadow:\n    0 var(--dsg-scroll-shadow-width) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    calc(0px - var(--dsg-scroll-shadow-width)) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    0 calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset,\n    var(--dsg-scroll-shadow-width) 0 var(--dsg-scroll-shadow-width)\n      calc(0px - var(--dsg-scroll-shadow-width)) var(--dsg-scroll-shadow-color)\n      inset;\n}\n\n.dsg-selection-col-marker-container {\n  position: absolute;\n  top: 0;\n}\n\n.dsg-selection-col-marker {\n  background: var(--dsg-selection-border-color);\n  position: sticky;\n  width: 100%;\n  height: var(--dsg-selection-border-width);\n}\n\n.dsg-selection-row-marker-container {\n  position: absolute;\n  left: 0;\n}\n\n.dsg-selection-row-marker {\n  background: var(--dsg-selection-border-color);\n  position: sticky;\n  height: 100%;\n  width: var(--dsg-selection-border-width);\n}\n\n.dsg-selection-col-marker-container,\n.dsg-selection-col-marker,\n.dsg-selection-row-marker-container,\n.dsg-selection-row-marker {\n  z-index: 20;\n  transition: all var(--dsg-transition-duration);\n  pointer-events: none;\n}\n\n.dsg-selection-col-marker-disabled,\n.dsg-selection-row-marker-disabled {\n  background: var(--dsg-selection-disabled-border-color);\n}\n\n.dsg-add-row {\n  background: #fafafa;\n  border: 1px solid var(--dsg-border-color);\n  border-top: none;\n  padding: 7px 10px;\n  display: flex;\n  align-items: center;\n  color: black;\n}\n\n.dsg-add-row > * {\n  margin-right: 10px;\n}\n\n.dsg-add-row-btn,\n.dsg-add-row-input {\n  background: white;\n  padding: 7px 10px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  border: 1px solid #dcdcdc;\n  border-radius: 2px;\n  transition: all 0.2s;\n}\n\n.dsg-add-row-input {\n  width: 55px;\n}\n\n.dsg-add-row-btn:hover,\n.dsg-add-row-input:hover {\n  border-color: #c7c7c7;\n}\n\n.dsg-add-row-btn:focus,\n.dsg-add-row-input:focus {\n  border-color: var(--dsg-selection-border-color);\n  outline: none;\n}\n\n.dsg-add-row-btn:before {\n  content: '';\n  display: inline-block;\n  margin-right: 10px;\n  background: #9da6ab;\n  width: 10px;\n  height: 2px;\n}\n\n.dsg-add-row-btn:after {\n  content: '';\n  display: block;\n  position: absolute;\n  left: 14px;\n  margin-right: 10px;\n  background: #9da6ab;\n  width: 2px;\n  height: 10px;\n}\n\n.dsg-input {\n  display: block;\n  flex: 1;\n  border: none;\n  min-width: 0;\n  align-self: stretch;\n  box-sizing: border-box;\n  background: none;\n  padding: 0 10px;\n  outline: none;\n}\n\n.dsg-input,\n.dsg-row {\n  font-size: calc(0.75 * var(--bs-body-font-size));\n}\n\n.dsg-input-suffix {\n  padding-right: 10px;\n  opacity: 0.5;\n  margin-left: -5px;\n}\n\n.dsg-input-align-right {\n  text-align: right;\n}\n\n.dsg-hide-date-picker[type='date']::-webkit-inner-spin-button,\n.dsg-hide-date-picker[type='date']::-webkit-calendar-picker-indicator {\n  display: none;\n  -webkit-appearance: none;\n}\n\n.dsg-checkbox {\n  margin: auto;\n}\n\n.dsg-context-menu {\n  position: fixed;\n  background: white;\n  z-index: 10000;\n  border-radius: 4px;\n  box-shadow: 0 2px 6px 2px rgba(60, 64, 67, 0.15);\n  padding: 5px 0;\n  color: black;\n}\n\n.dsg-context-menu-item {\n  padding: 3px 20px;\n  cursor: default;\n}\n\n.dsg-context-menu-item:hover {\n  background: #fafafa;\n}\n\n.dsg-expand-rows-indicator {\n  background: var(--dsg-cell-background-color);\n  border: solid 1px var(--dsg-selection-border-color);\n  box-shadow: 0 0 0 1px var(--dsg-cell-background-color);\n  width: var(--dsg-expand-rows-indicator-width);\n  height: var(--dsg-expand-rows-indicator-width);\n  box-sizing: border-box;\n  position: absolute;\n  transition: all var(--dsg-transition-duration);\n  cursor: crosshair;\n  z-index: 25;\n}\n\n.dsg-expand-rows-indicator-disabled {\n  border: solid 1px var(--dsg-selection-disabled-border-color);\n}\n\n.dsg-expand-rows-rect {\n  position: absolute;\n  box-sizing: border-box;\n  transition: all var(--dsg-transition-duration);\n  pointer-events: none;\n  background: rgba(0, 0, 0, 0.03);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
